import React, {useState, useEffect, useRef} from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem, TextField, Button, Typography, Box, Tooltip, IconButton, InputAdornment, CircularProgress,  } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Serviceurls } from "../../Utility/API/Serviceurls";
import { removeHyphen, removeSpaces } from "../../Components/CommonFunctions/CommonFunctions";
import RestAPIService from "../../Utility/Services/RestAPIService";
import CommonValidation from "../../Components/CommonFunctions/CommonValidation";
import Loader from '../../Components/Loader'
import { ConfirmPopup } from "../../Components/Common Components/CommonComponents";
import ToastMsg from "../../Components/ToastMsg/ToastMsg";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

const AbhaVerification = (props) => {
    const [verifyWith, setVerifyWith] = useState("AADHAAR");
    const [VerifyInput, setVerifyInput] = useState("");
    const [otp, setOtp] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [counter, setCounter] = useState(0);
    const [resendCount, setResendCount] = useState(0);
    const [isLoader, setLoader] = useState(false)
    const [isErrorStatus, setErrorStatus] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")
    const [btnDisable, setBtnDisable] = useState(false)
    const [isSuccStatus, setSuccStatus] = useState(false)
    const [succMsg, setSuccMsg] = useState("")
    const [otpVerified, setOtpVerified] = useState(false);
    const [patientData, setPatientDetails] = useState(null);
    const [currentTxnId, setCurrentTxnId] = useState("");
    const [copiedField, setCopiedField] = useState("");
    const timerRef = useRef(null);
    const [isRegistered, setIsRegistered] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [OtpMethod, setOtpMethod] = useState("AADHAAR_OTP");
    const [verifiedTxnId, setVerifiedTxnId] = useState("");
    const [verifiedToken, setVerifiedToken] = useState("");
    const [aadhaarMasked, setAadhaarMasked] = useState(true);
    const [havedata, setHavedata] = useState(false);
    const [mobileAbhaData, setMobileAbhaData] = useState(null);
    const [showMobileAbhaPopup, setShowMobileAbhaPopup] = useState(false);
    const [selectedAbha, setSelectedAbha] = useState(null);
    const [mobileAbhaTxnId, setMobileAbhaTxnId] = useState("");
    const [patientAbhaDetails, setPatientAbhaDetails] = useState(null)
    const [updateAbhaPopup, setUpdateAbhaPopup] = useState(false);
    const [existData, setExistData] = useState(null);
    const [patientID, setPatientID] = useState(null);
    const [OTPMethodDisable, setOTPMethodDisable] = useState(false)
    const [authMethods, setAuthMethods] = useState(["AADHAAR_OTP", "MOBILE_OTP"]);
    const [selectedAbhaDetail, setSelectedAbhaDetail] = useState({});

    useEffect(() => {
        if (otpSent && counter === 0) {
            setCounter(59);
        }
    }, [otpSent]);

    useEffect(() => {
        if (counter > 0) {
            timerRef.current = setTimeout(() => setCounter(counter - 1), 1000);
        }
        return () => clearTimeout(timerRef.current);
    }, [counter]);

    const msgClose = () => {
        setErrorStatus(false)
        setErrorMsg('')
        setSuccMsg('')
        setSuccStatus(false)
    }

    const errorMessage = (message) => {
        setErrorStatus(true)
        setErrorMsg(message)
        setBtnDisable(false)
    }

    const successMessage = (message) => {
        setSuccMsg(message)
        setSuccStatus(true)
    }

    const handleVerifyInputChange = (value) => {
        if (verifyWith === "AADHAAR") {
            value = value.replace(/\D/g, "").slice(0, 12);
            value = value.replace(/(\d{4})/g, "$1 ").trim();
            setVerifyInput(value)
        } else if (verifyWith === "MOBILE") {
            if (CommonValidation.numberOnly(value) || (value === "")) {
                setVerifyInput(value)
            }
        } else if (verifyWith === "ABHA NO") {
            value = value.replace(/\D/g, "").slice(0, 14);
            let formatted = value.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})(\d{0,4})$/, function(_, g1, g2, g3, g4) {
                return [g1, g2, g3, g4].filter(Boolean).join('-');
            });
            setVerifyInput(formatted)
        } else if (verifyWith === "ABHA AD") {
            value = value.replace(/@/g, '').replace(/\s/g, '');
            setVerifyInput(value)
        } else {
        value = value.trim();
        setVerifyInput(value)
        }
    }

    const hadleMobileAbhaCheck = () => {
        try {
            setLoader(true)
            setBtnDisable(true)
            var data = {
                "mobile": VerifyInput,
                "using": "mobile"
            }
            RestAPIService.create(data, Serviceurls.HAVE_ABHA_MOBILE_CHECK)
            .then(response => {
                setLoader(false)
                setBtnDisable(false)
                if (response.data.status === "success") {
                    setMobileAbhaData(response.data?.data[0]?.ABHA)
                    setMobileAbhaTxnId(response.data?.data[0]?.txnId)
                    setShowMobileAbhaPopup(true);
                }else {
                    
                    if(parseInt(VerifyInput[0]) > 5){
                        errorMessage("No ABHA Profile Found")
                    }else{
                        errorMessage("Please enter valid Mobile Number");
                    }
                }
            })
            .catch(e => {
                setLoader(false)
                setBtnDisable(false)
                if (e?.response?.data?.status === "fail") {
                    if(parseInt(VerifyInput[0]) > 5){
                        errorMessage("No ABHA Profile Found")
                    }else{
                        errorMessage("Please enter valid Mobile Number");
                    }
                } else {
                    if(parseInt(VerifyInput[0]) > 5){
                        errorMessage("No ABHA Profile Found")
                    }else{
                        errorMessage("Please enter valid Mobile Number");
                    }
                }
            })
        } catch (e) {
            setLoader(false)
            setBtnDisable(false)
            errorMessage(e.message)
        }
    }

    const handleGenerateOtp = (resend = 0) => {
        try {
            setLoader(true)
            setBtnDisable(true)
            var data = {}
            var URL = Serviceurls.HAVE_ABHA_OTP_REQUEST
            if (verifyWith === "AADHAAR") {
                var Aadhaar = removeSpaces(VerifyInput)
                data = {
                    "loginHint": "aadhaar",
                    "loginId": Aadhaar,
                    "otpSystem": "aadhaar",
                }
            } else if (verifyWith === "MOBILE") {
                data = {
                    "loginHint": "mobile-index",
                    "loginId": selectedAbha ? (selectedAbha).toString() : "",
                    "otpSystem": "abdm",
                    "txnId": mobileAbhaTxnId ? mobileAbhaTxnId : "",
                }
            } else if (verifyWith === "ABHA NO") {
                var AbhaNum = (VerifyInput)
                data = {
                    "loginHint": "abha-number",
                    "loginId": AbhaNum,
                    "otpSystem": OtpMethod === "AADHAAR_OTP" ? "aadhaar" : "abdm"
                }
            } else if (verifyWith === "ABHA AD") {
                var AbhaAddress = (VerifyInput.trim() ? VerifyInput.trim() + "@sbx" : "");
                data = {
                    "loginHint": "abha-address",
                    "loginId": AbhaAddress,
                    "otpSystem": OtpMethod === "AADHAAR_OTP" ? "aadhaar" : "abdm"
                }
            }

            RestAPIService.create(data, URL)
            .then(response => {
                setLoader(false)
                setBtnDisable(false)
                if (response?.data?.status == "success") {
                    var Data = response?.data?.data
                    setCurrentTxnId(Data?.txnId)
                    setOtpSent(true);
                    setCounter(59);
                    setResendCount(resendCount + resend)
                    successMessage(response.data?.data?.message || response.data?.content?.message || response.data?.message)
                } else {
                    let  OtpHead = verifyWith === "ABHA AD" ? "ABHA Address" : verifyWith === "ABHA NO" ? "ABHA Number" : verifyWith === "AADHAAR" ? "Aadhaar Number" : "Mobile Number";
                    errorMessage(`Invalid ${OtpHead}`);
                }
            })
            .catch(e => {
                setLoader(false)
                if (e?.response?.data?.status === "fail") {
                    let  OtpHead = verifyWith === "ABHA AD" ? "ABHA Address" : verifyWith === "ABHA NO" ? "ABHA Number" : verifyWith === "AADHAAR" ? "Aadhaar Number" : "Mobile Number";
                    errorMessage(`Invalid ${OtpHead}`);
                } else {
                    let  OtpHead = verifyWith === "ABHA AD" ? "ABHA Address" : verifyWith === "ABHA NO" ? "ABHA Number" : verifyWith === "AADHAAR" ? "Aadhaar Number" : "Mobile Number";
                    errorMessage(`Invalid ${OtpHead}`);
                }
            })     
            
        }catch (e) {
            errorMessage(e.message)
        }
    }

    const handleVerifyOtp = () => {
        try {
            setLoader(true)
            setBtnDisable(true)
            URL = Serviceurls.HAVE_ABHA_OTP_VERIFY
            var data = {}
            if (verifyWith === "AADHAAR") {
                data = {
                    "loginHint": "aadhaar",
                    "otpSystem": "aadhaar",
                    "otp": otp,
                    "txnId": currentTxnId ? currentTxnId : "",
                }
            } else if (verifyWith === "MOBILE") {
                data = {
                    "loginHint": "mobile",
                    "otpSystem": "abdm",
                    "otp": otp,
                    "txnId": currentTxnId ? currentTxnId : "",
                }
            }else if (verifyWith === "ABHA NO") {
                data = {
                    "loginHint": "abha-number",
                    "otpSystem": OtpMethod === "AADHAAR_OTP" ? "aadhaar" : "abdm",
                    "otp": otp,
                    "txnId": currentTxnId ? currentTxnId : "",
                }
            } else if (verifyWith === "ABHA AD") {
                data = {
                    "loginHint": "abha-address",
                    "otpSystem": OtpMethod === "AADHAAR_OTP" ? "aadhaar" : "abdm",
                    "otp": otp,
                    "txnId": currentTxnId ? currentTxnId : "",
                }
            }

            RestAPIService.create(data, URL)
            .then(response => {
                    setLoader(false)
                    setBtnDisable(false)
                if (response.data.status == "success") {
                    setOtpVerified(true);
                    var abhaData = verifyWith === "ABHA AD" ? response?.data?.data?.users[0] : response?.data?.data?.accounts[0];
                    var patientRecord = response?.data?.data?.profile;
                    var Token = verifyWith === "ABHA AD" ? response?.data?.data?.tokens?.token : response?.data?.data?.token;
                    setPatientDetails(patientRecord);
                    setPatientAbhaDetails(abhaData)
                    setVerifiedTxnId(response?.data?.data?.txnId);
                    setVerifiedToken(Token);
                    setHavedata(true);
                    setMobileAbhaData(null);
                    setShowMobileAbhaPopup(false);
                    setSelectedAbha(null);
                    setSelectedAbhaDetail({});
                    setMobileAbhaTxnId("");
                    successMessage(response.data?.data?.message || response.data?.message)
                } else {
                    errorMessage(response.data?.error?.message || response.data?.message)
                }
            })
            .catch(e => {
                setLoader(false)
                if (e?.response?.data?.status === "fail") {
                    errorMessage(e.response.data.message)
                } else {
                    errorMessage(e.message)
                }

            })
        }catch (e) {
            errorMessage(e.message)
        }
    }

    const handleCopy = (value, field) => {
        navigator.clipboard.writeText(value).then(() => {
            setCopiedField(field);
            setTimeout(() => setCopiedField(""), 2000); // Reset copied state after 2s
        });
    };

    const formAllClear = () => {
        setVerifyWith("AADHAAR")
        setVerifyInput("");
        setOtp("");
        setOtpSent(false);
        setCounter(0);
        setResendCount(0);
        setLoader(false);
        setBtnDisable(false);
        setOtpVerified(false);
        setPatientDetails(null);
        setCurrentTxnId("");
        setCopiedField("");  
        setVerifiedToken("");
        setVerifiedTxnId("");
        setHavedata(false);
        setMobileAbhaData(null);
        setShowMobileAbhaPopup(false);
        setSelectedAbha(null);
        setSelectedAbhaDetail({});
        setMobileAbhaTxnId("");
        setAadhaarMasked(true); 
        setPatientAbhaDetails(null)
        setIsRegistered(false)
        setPopupData(null)
        setUpdateAbhaPopup(false);
        setExistData(null);
        setPatientID(null);
        setOtpMethod("AADHAAR_OTP");
        setOTPMethodDisable(false)
    }

    const downloadAbhaCard = () => {
        try {
            setLoader(true)
            var data = {
                "xtoken": verifiedToken,
                "txn_id": verifiedTxnId ? verifiedTxnId : currentTxnId,
                "file_for": "verify"
            }
            if(verifyWith === "ABHA AD"){
                data['request_from'] = "abha-address"
            }
            RestAPIService.abhaVerifyDownload(data, Serviceurls.ABHA_PATIENT_ABHA_CARD_DOWNLOAD)
                .then(response => {
                    setLoader(false)
                    if (response) {
                        const base64 = btoa(
                        new Uint8Array(response.data)
                            .reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );
                        const base64Image = `data:image/png;base64,${base64}`;
                        const imgWindow = window.open();
                        imgWindow.document.write(`<img src="${base64Image}">`);
                    } else {
                        errorMessage(response.data?.message)
                    }
                })
                .catch(e => {
                    setLoader(false)
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {   
            setLoader(false)
            setBtnDisable(false)
            errorMessage(e.message)
        }
    }

    const searchAuthmode = () => {
        try {
            setLoader(true)
            setBtnDisable(true)
            URL = Serviceurls.SEARCH_OTP_AUTH_MODE
            var data = {
                "abha_address": VerifyInput.trim() ? VerifyInput.trim() + "@sbx" : ""
            }

            RestAPIService.create(data, URL)
            .then(response => {
                    setLoader(false)
                    setBtnDisable(false)
                if (response.data.status == "success") {
                    setAuthMethods(response?.data?.data?.authMethods)
                    setOTPMethodDisable(false)
                    // successMessage(response.data?.data?.message || response.data?.message)
                } else {
                    errorMessage(response.data?.error?.message || response.data?.message)
                }
            })
            .catch(e => {
                setLoader(false)
                if (e?.response?.data?.status === "fail") {
                    errorMessage(e.response.data.message)
                } else {
                    errorMessage(e.message)
                }

            })

        }catch (e) {
            errorMessage(e.message)
        }
    }

    const registerAbhaPatient = () => {
        try {
            setLoader(true)
            setBtnDisable(true)
            var DOB = [patientData?.yearOfBirth, patientData?.monthOfBirth, patientData?.dayOfBirth].filter(Boolean).join("-")
            // DOB = patientData?.dob ? DateTime.fromFormat(patientData?.dob, "dd-MM-yyyy").toFormat("yyyy-MM-dd") : null
            var AbhaNum = patientData?.abhaNumber || patientData?.ABHANumber
            AbhaNum = AbhaNum ? removeHyphen(AbhaNum) : ""
            var data = {
                "dob": DOB,
                "first_name": patientData?.firstName,
                "mobile": patientData?.mobile,
                "middle_name": patientData?.middleName,
                "last_name": patientData?.lastName,
                "gender": patientData?.gender ? (patientData?.gender).toLowerCase() : "",
                "email": patientData?.email ? patientData?.email : "",
                "address": patientData?.address,
                "district": patientData?.districtName,
                "pincode": patientData?.pinCode ? patientData?.pinCode : patientData?.pincode,
                "state": patientData?.stateName,
                "abha_id": AbhaNum,
                "abha_address": patientAbhaDetails?.preferredAbhaAddress || patientAbhaDetails?.abhaAddress,
                "link_hip": true,
            }
            if (patientID) {
                data['uhid'] = patientID
                data['allow_update'] = true;
                data['link_hip'] = false; 
            }
            RestAPIService.create(data, Serviceurls.ABHA_PATIENT_ABHA_REGISTER)
                .then(response => {
                    setLoader(false)
                    setBtnDisable(false)
                    if (response.data.status == "success") {
                        if(response.data?.message === "Patient is already mapped with the ABHA service.") {
                            setUpdateAbhaPopup(true)
                            setExistData(response.data?.existing_data)
                            setPatientID(response.data?.uhid)
                        }else{
                            successMessage(response.data?.message)
                            setPopupData(response.data?.data)
                            setIsRegistered(true)
                            setUpdateAbhaPopup(false);
                            setExistData(null);
                        }
                        
                    } else {
                        errorMessage(response.data?.message)
                    }
                })
                .catch(e => {
                    setLoader(false)
                    if (e?.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }

                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const renderUpdateAbhaPopup = () => {
        try {
            if (!existData || !patientData) return null;
            return (
                <Box
                    sx={{
                        position: "fixed",
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: "rgba(0,0,0,0.3)",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    {isLoader && (
                    <Box
                        sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        bgcolor: 'rgba(255,255,255,0.5)',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 2
                        }}
                    >
                        <CircularProgress />
                    </Box>
                    )}
                    <Box sx={{ background: "#fff", p: 4, borderRadius: 2, minWidth: 700, maxWidth: "90vw" }}>
                        <Typography variant="h5" mb={2} align="center">
                            Update Patient Data
                        </Typography>
                        <Typography variant="subtitle1" mb={3} align="center" color="primary">
                            Patient already linked with this hospital - UHID is {patientID}
                        </Typography>
                        <Grid container spacing={3}>
                            {/* Existing Patient Section */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, background: "#f9f9f9", height: "55vh", overflowY: "auto" }}>
                                    <Typography variant="subtitle2" mb={1} color="textSecondary">
                                        Existing Patient Data
                                    </Typography>
                                    <Typography><strong>Name:</strong> {[existData?.first_name, existData?.middle_name, existData?.last_name].filter(Boolean).join(" ")}</Typography>
                                    <Typography><strong>Mobile:</strong> {existData?.mobile}</Typography>
                                    <Typography><strong>ABHA Address:</strong> {existData?.abha_health_address}</Typography>
                                    <Typography><strong>ABHA Number:</strong> {existData?.abha_health_id}</Typography>
                                    <Typography><strong>Gender:</strong> {existData?.gender}</Typography>
                                    <Typography><strong>DOB:</strong> {existData?.dob}</Typography>
                                    <Typography><strong>Address:</strong> {existData?.address}</Typography>
                                    <Typography><strong>Pincode:</strong> {existData?.pincode}</Typography>
                                    <Typography><strong>District:</strong> {existData?.dst_name}</Typography>
                                    <Typography><strong>State:</strong> {existData?.state_name}</Typography>
                                    {/* Add more fields as needed */}
                                </Box>
                            </Grid>
                            {/* New Patient Section */}
                            <Grid item xs={12} md={6}>
                                <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, background: "#f9f9f9", position: "relative", height: "55vh", overflowY: "auto" }}>
                                    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                        <Typography variant="subtitle2" mb={1} color="textSecondary">
                                            ABHA Data
                                        </Typography>
                                        {patientAbhaDetails?.profilePhoto && (
                                            <img
                                                src={`data:image/jpeg;base64,${patientAbhaDetails.profilePhoto}`}
                                                alt="Patient"
                                                style={{ width: 60, height: 70, borderRadius: 5, objectFit: "cover", marginLeft: 8 }}
                                            />
                                        )}
                                    </Box>
                                    <Typography><strong>Name:</strong> {[patientData?.firstName, patientData?.middleName, patientData?.lastName].filter(Boolean).join(" ")}</Typography>
                                    <Typography><strong>Mobile:</strong> {patientData?.mobile}</Typography>
                                    {/* <TextField
                                        label="Mobile"
                                        size="small"
                                        value={patientData?.mobile || ""}
                                        onChange={e => setPatientDetails({ ...patientData, mobile: e.target.value })}
                                        
                                        sx={{ my: 1, width: "50%" }}
                                    /> */}
                                    <Typography><strong>ABHA Address:</strong> {(patientAbhaDetails?.preferredAbhaAddress || patientAbhaDetails?.abhaAddress)}</Typography>
                                    <Typography><strong>ABHA Number:</strong> {(patientAbhaDetails?.ABHANumber || patientAbhaDetails?.abhaNumber)}</Typography>
                                    <Typography><strong>Gender:</strong> {patientData?.gender}</Typography>
                                    <Typography><strong>DOB:</strong> {[patientData?.dayOfBirth, patientData?.monthOfBirth, patientData?.yearOfBirth].filter(Boolean).join("-")}</Typography>
                                    <Typography><strong>Address:</strong> {patientData?.address}</Typography>
                                    {/* <TextField
                                    label="Address"
                                    size="small"
                                    value={patientData?.address || ""}
                                    onChange={e => setPatientDetails({ ...patientData, address: e.target.value })}
                                    multiline
                                    maxRows={2}
                                    sx={{ my: 1, width: "100%" }}
                                    /> */}
                                    <Typography><strong>Pincode:</strong> {patientData?.pincode || patientData?.pinCode}</Typography>
                                    <Typography><strong>District:</strong> {patientData?.districtName}</Typography>
                                    <Typography><strong>State:</strong> {patientData?.stateName}</Typography>
                                    {/* Add more fields as needed */}
                                </Box>
                            </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" mt={4}>
                            <Button
                                variant="outlined"
                                color="primary"
                                sx={{mr: 2, textTransform:'capitalize'}}
                                onClick={() => {
                                    setUpdateAbhaPopup(false)
                                    setExistData(null)
                                    setPatientID(null)
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                sx={{ textTransform:'capitalize'}}
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    registerAbhaPatient();
                                }}
                            >
                                Proceed
                            </Button>
                        </Box>
                    </Box>
                </Box>
            );
        } catch (e) {
            console.error("Error rendering update ABHA popup:", e);
            return null;
        }
    };

    const renderMobileAbhaPopup = () => {
        try {
            return (
                <Box
                    sx={{
                        position: "fixed",
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: "rgba(0,0,0,0.3)",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <Box sx={{ background: "#fff", p: 4, borderRadius: 2, minWidth: 400, display: "flex", flexDirection: "column" }}>
                        {!otpSent ? (
                        <Typography variant="h6" mb={2}>
                            We found that ABHA number(s) associated with your mobile number
                        </Typography>
                        ) : (
                            <Typography variant="h6" mb={2}>
                            Enter OTP to verify for
                            </Typography>
                        ) }
                        {!otpSent ? (
                        <Box mb={3} sx={{ maxHeight: { xs: '40vh', md: '50vh' }, overflowY: "auto" }}>
                        <FormControl component="fieldset" fullWidth>
                            <Grid container spacing={2}>
                                {mobileAbhaData.map((item, idx) => (
                                    <Grid item xs={12} key={item.index}>
                                        <Box
                                            sx={{
                                                border: selectedAbha === item.index ? "2px solid #1976d2" : "1px solid #ccc",
                                                borderRadius: 2,
                                                p: 2,
                                                display: "flex",
                                                alignItems: "flex-start",
                                                background: selectedAbha === item.index ? "#f0f7ff" : "#fff",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => {
                                                if(!otpSent){
                                                setSelectedAbha(item.index)
                                                setSelectedAbhaDetail(item)
                                                }
                                            }}
                                        >
                                            <input
                                                type="radio"
                                                checked={selectedAbha === item.index}
                                                disabled={otpSent}
                                                onChange={() => {
                                                    setSelectedAbha(item.index);
                                                    setSelectedAbhaDetail(item);
                                                }}
                                                id={`abha-radio-${idx}`}
                                                style={{ marginTop: 4 }}
                                            />
                                            <Box ml={2} width="100%">
                                                <Typography variant="body2" color="textSecondary">
                                                    <strong>ABHA Number:</strong> {item.ABHANumber}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    <strong>Name:</strong> {item.name || item.fullName}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    <strong>Gender:</strong> {item.gender}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </FormControl>
                        </Box> ) : null}
                        <Box>
                        {!otpSent ? (
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!selectedAbha}
                                onClick={() => {
                                    // Use your existing handleGenerateOtp logic, but pass selectedAbha
                                    handleGenerateOtp(0, selectedAbha);
                                }}
                                sx={{ mt: 2, textTransform:'capitalize' }}
                            >
                                Send OTP
                            </Button>
                        ) : (
                            <>
                               <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"flex-start"} gap={"0.5vw"}>
                                <Typography sx={{ fontSize: "0.95vw"}}>
                                <strong>ABHA Number:</strong> {selectedAbhaDetail?.ABHANumber || "-"}
                                </Typography>
                                <Typography sx={{ fontSize: "0.95vw"}}>
                                <strong>Name:</strong> {selectedAbhaDetail?.name || selectedAbhaDetail?.fullName || "-"}
                                </Typography>
                                </Box>
                                <TextField
                                    label="Enter OTP"
                                    value={otp}
                                    onChange={e => setOtp(e.target.value)}
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    inputProps={{ maxLength: 6 }}
                                />
                                <Box display="flex" alignItems="center" mt={2}>
                                    <Button
                                        sx={{ textTransform:'capitalize'}}
                                        variant="outlined"
                                        color="primary"
                                        disabled={counter > 0 || resendCount >= 2}
                                        onClick={() => {
                                            handleGenerateOtp(1, selectedAbha);
                                        }}
                                    >
                                        {counter > 0 ? `Resend OTP (${counter}s)` : "Resend OTP"}
                                    </Button>
                                    <Typography variant="caption" sx={{ ml: 2 }}>
                                        Remaining resend: {resendCount} / 2
                                    </Typography>
                                </Box>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{ mt: 2, textTransform:'capitalize' }}
                                    disabled={otp.length !== 6}
                                    onClick={() => {
                                        // Use your existing handleVerifyOtp logic, but pass selectedAbha
                                        handleVerifyOtp(selectedAbha);
                                    }}
                                >
                                    Verify OTP
                                </Button>
                            </>
                        )}
                            <Button
                                variant="text"
                                color="secondary"
                                sx={{ mt: 2, textTransform:'capitalize' }}
                                onClick={() => {
                                    setShowMobileAbhaPopup(false)
                                    setMobileAbhaData(null)
                                    setOtpSent(false)
                                    setSelectedAbha(null)
                                    setMobileAbhaTxnId("")
                                }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )
        } catch (e) {
            console.error("Error rendering mobile ABHA popup:", e);
            return null;
        }
    }


    return (
        <div style={{ padding: "20px", margin: "auto", backgroundColor: "#fff", height: "80vh" }}>
            <div style={{ height: "65vh" }}>
                <Grid container spacing={2} alignItems="center" mt={'1vh'}>
                    <Grid item xs={5}>
                        <FormControl disabled={havedata || otpSent} fullWidth style={{ marginBottom: "10px" }}>
                        <InputLabel id="verify-with-label">Verify With</InputLabel>
                        <Select
                            labelId="verify-with-label"
                            id="verify-with"
                            value={verifyWith}
                            onChange={(e) => {
                                setVerifyWith(e.target.value)
                                setVerifyInput("")
                                if(e.target.value == "ABHA AD"){
                                    setOtpMethod("")
                                    setOTPMethodDisable(true)
                                }
                                if(e.target.value === "ABHA NO" && !OtpMethod){
                                    setOtpMethod("AADHAAR_OTP")
                                    setOTPMethodDisable(false)
                                }
                            }}
                            size="small"
                            label="Verify With"
                            disable={havedata || otpSent}
                        >
                                <MenuItem value="AADHAAR">Aadhaar Number</MenuItem>
                                <MenuItem value="MOBILE">Mobile Number</MenuItem>
                                <MenuItem value="ABHA NO">Abha Number</MenuItem>
                                <MenuItem value="ABHA AD">Abha Address</MenuItem>
                        </Select>
                    </FormControl>
                    </Grid>
                    {((verifyWith === "ABHA NO") || (verifyWith === "ABHA AD")) && (
                    <Grid item xs={5}>
                        <FormControl fullWidth style={{ marginBottom: "10px" }}>
                        <InputLabel id="otp-method-label">OTP Method</InputLabel>
                        <Select
                            labelId="otp-method-label"
                            id="otp-method"
                            value={OtpMethod}
                            onChange={(e) => {
                                setOtpMethod(e.target.value)
                            }}
                            size="small"
                            label="OTP Method"
                            disabled={havedata || otpSent || OTPMethodDisable}
                        >
                            {authMethods.map((method) => (
                                <MenuItem key={method} value={method}>{method === "AADHAAR_OTP" ? "Aadhaar OTP" : method === "MOBILE_OTP" ? "Mobile OTP" : method}</MenuItem>
                            ))}
                            {/* <MenuItem value="AADHAAR">Aadhaar OTP</MenuItem>
                            <MenuItem value="MOBILE">Mobile OTP</MenuItem> */}
                        </Select>
                    </FormControl>
                    </Grid>
                    )}
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={'1vh'}>
                    <Grid item xs={5}>
                        <TextField
                            size="small"
                            label={(verifyWith === "AADHAAR") ? "Aadhaar Number" : (verifyWith === "ABHA NO") ? "ABHA Number" : (verifyWith === "ABHA AD") ? "ABHA Address" : "Mobile Number"}
                            value={VerifyInput}
                            onChange={(e) => handleVerifyInputChange(e.target.value)}
                            fullWidth
                            // inputProps={{ maxLength: ((verifyWith === "AADHAAR") ? 14 : (verifyWith === "ABHA NO") ? 17 : (verifyWith === "MOBILE") ? 10 : 50) }}
                            // type={aadhaarMasked ? "password" : "text"}
                            type={"text"}
                            inputProps={{
                                maxLength: ((verifyWith === "AADHAAR") ? 14 : (verifyWith === "ABHA NO") ? 17 : (verifyWith === "MOBILE") ? 10 : 50),
                                autoComplete: "off",
                                style: {
                                    WebkitTextSecurity: aadhaarMasked ? "disc" : "none"
                                }
                            }}
                            disabled={havedata || otpSent}
                            InputProps={{
                                endAdornment: verifyWith === "ABHA AD" ? (
                                    <InputAdornment position="end">
                                        <Box display="flex" alignItems="center">
                                            <Typography sx={{ color: "#888", fontSize: 14, mr: 1 }}>@sbx</Typography>
                                            {verifyWith === "ABHA AD" ? 
                                            <IconButton aria-label="search" onClick={() => {
                                                searchAuthmode()
                                            }} edge="end" disabled={havedata || otpSent} size="small">
                                            <SearchOutlinedIcon />
                                            </IconButton> : null}
                                            <IconButton
                                                aria-label={aadhaarMasked ? "Show" : "Hide"}
                                                onClick={() => setAadhaarMasked((prev) => !prev)}
                                                edge="end"
                                                disabled={havedata}
                                                size="small"
                                            >
                                                {aadhaarMasked ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                            </IconButton>
                                        </Box>
                                    </InputAdornment>
                                ) : (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={aadhaarMasked ? "Show" : "Hide"}
                                            onClick={() => setAadhaarMasked((prev) => !prev)}
                                            edge="end"
                                            disabled={havedata}
                                            size="small"
                                        >
                                            {aadhaarMasked ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        /> 
                    </Grid>
                    <Grid item xs={5} display={"flex"} flexDirection={"row"} justifyContent={"space-evenly"}>
                        {verifyWith != "MOBILE" ? <TextField
                            size="small"
                            label="Enter OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            fullWidth
                            disabled={!otpSent || havedata}
                            inputProps={{ maxLength: 6 }}
                        /> : null}
                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" style={{ marginTop: 10 }}>
                    <Grid item xs={5}>
                        {verifyWith != "MOBILE" ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={
                                () => {
                                    if (counter === 0 & otpSent){ handleGenerateOtp(1)
                                    } else { handleGenerateOtp() }
                            
                                }}
                            disabled={btnDisable || (counter > 0) || (resendCount > 1) || havedata || ((verifyWith === "ABHA NO" || verifyWith === "ABHA AD") && !OtpMethod)}
                            sx={{ marginLeft: 5, textTransform:'capitalize' }}
                        >
                            {(otpSent && (!havedata) && counter > 0) ? `Resend OTP (${counter}s)` : otpSent ? "Re Send" : "Get OTP"}
                        </Button>
                        ) : null}
                        {(verifyWith === "MOBILE") ? (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={
                                    () => { hadleMobileAbhaCheck()}}
                                disabled={btnDisable || havedata}
                                sx={{ marginLeft: 5, textTransform:'capitalize' }}
                            >
                                {"Search ABHA"}
                            </Button>
                        ) : null}
                    </Grid>
                    <Grid item xs={5}>
                        {verifyWith != "MOBILE" ? 
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleVerifyOtp}
                            sx={{ marginLeft: 5, textTransform:'capitalize' }}
                            disabled={((otp.length !== 6) || btnDisable || havedata)}
                        >
                            Verify OTP
                        </Button> : null}
                    </Grid>
                </Grid>
                {otpSent && verifyWith != "MOBILE" ? (
                    <Typography
                        variant="caption"
                        color="textSecondary"
                        sx={{ display: "block", marginTop: "4px", marginLeft: 5, }}
                    >
                        Remaining resend OTP: {resendCount + " / 2"}
                    </Typography>
                ) : null}
                {otpVerified && patientData && (
                    <Grid container spacing={2} style={{ marginTop: 20 }}>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1"><strong>Patient Details</strong></Typography>
                            <Typography>Name: {[patientData?.firstName, patientData?.middleName, patientData?.lastName].filter(Boolean).join(" ")}</Typography>
                            <Typography>Gender: {patientData?.gender}</Typography>
                            <Typography>DOB: {[patientData?.dayOfBirth, patientData?.monthOfBirth, patientData?.yearOfBirth].filter(Boolean).join("-")}</Typography>
                            <Typography>Mobile: {patientData?.mobile}</Typography>
                            <Typography>Address: {patientData?.address}</Typography>
                            <Typography>District: {patientData?.districtName}</Typography>
                            <Typography>State: {patientData?.stateName}</Typography>
                            <Typography>Pincode: {patientData?.pincode || patientData?.pinCode}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle1"><strong>ABHA Details</strong></Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography>ABHA Address: { (patientAbhaDetails?.preferredAbhaAddress || patientAbhaDetails?.abhaAddress) }</Typography>
                                <Tooltip title={copiedField === "abha_address" ? "Copied!" : "Copy"}>
                                    <IconButton onClick={() => handleCopy((patientAbhaDetails?.preferredAbhaAddress || patientAbhaDetails?.abhaAddress), "abha_address")} color="primary" size="small">
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography>ABHA Number: {(patientAbhaDetails?.ABHANumber || patientAbhaDetails?.abhaNumber)}</Typography>
                                <Tooltip title={copiedField === "abha_number" ? "Copied!" : "Copy"}>
                                    <IconButton onClick={() => handleCopy((patientAbhaDetails?.ABHANumber || patientAbhaDetails?.abhaNumber), "abha_number")} color="primary" size="small">
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Typography>ABHA Status: {patientAbhaDetails?.status}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <img
                                src={patientData.profilePhoto ? `data:image/jpeg;base64,${patientData.profilePhoto}` : ""}
                                alt="Patient"
                                style={{ width: 100, height: 120, borderRadius: 5 }}
                            />
                        </Grid>
                        {/* <Grid item xs={8}>
                            <Typography variant="subtitle1"><strong>Patient Details</strong></Typography>
                            <Typography>Name: {patientData?.name || patientData?.fullName}</Typography>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography>ABHA Address: {patientData?.preferredAbhaAddress || patientData?.abhaAddress}</Typography>
                                <Tooltip title={copiedField === "abha_address" ? "Copied!" : "Copy"}>
                                    <IconButton onClick={() => handleCopy((patientData?.preferredAbhaAddress || patientData?.abhaAddress), "abha_address")} color="primary" size="small">
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography>ABHA Number: {patientData?.ABHANumber || patientData?.abhaNumber}</Typography>
                                <Tooltip title={copiedField === "abha_number" ? "Copied!" : "Copy"}>
                                    <IconButton onClick={() => handleCopy((patientData?.ABHANumber || patientData?.abhaNumber), "abha_number")} color="primary" size="small">
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Typography>ABHA Status: {patientData?.status}</Typography>
                        </Grid>
                        
                        <Grid item xs={4}>
                            <img
                                src={patientData?.profilePhoto ? `data:image/jpeg;base64,${patientData.profilePhoto}` : ""}
                                alt="Patient"
                                style={{ width: 100, height: 120, borderRadius: 5 }}
                            />
                        </Grid> */}
                    </Grid>
                )}
            </div>
            <div style={{ height: "15vh" }}>
                <Grid container justifyContent="end" style={{ marginTop: '2vh' }}>
                    <Button variant='outlined' color="primary" sx={{marginRight: '1.5vw', textTransform:'capitalize'}} onClick={() => {
                        formAllClear()
                    }}>
                        Clear
                    </Button>
                    <Button variant="contained" color="primary" sx={{marginRight: '1.5vw', textTransform:'capitalize'}} onClick={() => {
                        downloadAbhaCard()
                    }} disabled={!otpVerified || !havedata}>
                        Download ABHA Card
                    </Button>
                    <Button variant="contained"
                        sx={{ textTransform:'capitalize'}}
                        color="primary"
                        disabled={(!otpVerified || !havedata)}
                        onClick={() => {
                            registerAbhaPatient()
                        }}
                    >
                        Register / Update
                    </Button>
                </Grid>
            </div>
            <Loader loaderOpen={isLoader} />
            {showMobileAbhaPopup  ? 
            renderMobileAbhaPopup() : null}
            {(isErrorStatus && errorMsg ) ?
            <ToastMsg
            severity={'error'}
            msg={errorMsg}
            msgPop={msgClose}
            />
            : null}
            {(isSuccStatus && succMsg) ?
            <ToastMsg
            severity={'success'}
            msg={succMsg}
            msgPop={msgClose}
            />
            : null}
            {updateAbhaPopup ?
            renderUpdateAbhaPopup() : null
            }
            {isRegistered ?
            <ConfirmPopup
                cnfAlertPopupClose={() => formAllClear()}
                cnfTitle={"Patient Registered Successfully"}
                cnfAbhaRegister={popupData}
                btnText1={"OK"}
                btnText2={"Download ABHA"}
                cnfData = {downloadAbhaCard}
            />
            : null}
        </div>
    )
}

export default AbhaVerification;